<template>
  <div>
    <CommonForm @search="formSearch" :form-json="formjson" />
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      @change="handleTableChange"
      :table-json="tablejson"
    >
    </CommonTable>
  </div>
</template>

<script>
import tablejson from './Model/Tablejson.Index'
import formjson from './Model/Formjson.Index'
import formTableMixin from '@/mixins/formTableMixin'
export default {
  mixins: [formTableMixin],
  props: {
    productKey: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tablejson,
      formjson,
      queryApi: this.$api.device.device_report_log_list
    }
  },
  methods: {
    formSearch(data) {
      const params = {
        ...data,
        deviceId: this.$route.query.id,
        productKey: this.productKey
      }
      if (!this.hasGetTslCol) {
        this.hasGetTslCol = true
        this.getTslColData()
      }
      this.search(params, null, this.queryApi)
    },
    filterArr(tempArr, property) {
      for (let i = 0; i < tempArr.length; i++) {
        for (let j = i + 1; j < tempArr.length; j++) {
          if (tempArr[i][property] == tempArr[j][property]) {
            tempArr.splice(j, 1)
            j--
          }
        }
      }
      return tempArr
    },

    getTslColData() {
      this.$ajax
        .get(this.$api.product.product_tsl_property_list, {
          productKey: this.productKey
        })
        .then((res) => {
          if (res.success) {
            console.log(res.data)
            res.data.map((item) => {
              if (item.dataType === 'array' || item.dataType === 'struct') {
                this.tablejson.push({
                  filed: item.identifier,
                  label: item.name,
                  type: 'span',
                  width: '150px',
                  formatFn: function(_, row) {
                    if (typeof row[item.identifier] === 'object') {
                      return (row[item.identifier] && JSON.stringify(row[item.identifier])) || '-'
                    } else {
                      return row[item.identifier] || '-'
                    }
                  }
                })
              } else if (item.dataType === 'float') {
                this.tablejson.push({
                  width: '150x',
                  filed: item.identifier,
                  label: item.name,
                  type: 'span',
                  formatFn: function(_, row) {
                    return row[item.identifier].toFixed(1)
                  }
                })
              } else {
                this.tablejson.push({
                  width: '150x',
                  filed: item.identifier,
                  label: item.name,
                  type: 'span'
                })
              }
            })
            this.tablejson = this.filterArr(this.tablejson, 'filed')
          } else {
            this.$message.error(res.msg)
          }
        })
    }
  }
}
</script>

<style></style>
